import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "question-box me-5 ms-5 mt-7" }
const _hoisted_2 = { class: "question-num" }
const _hoisted_3 = { class: "pb-10" }
const _hoisted_4 = {
  key: 0,
  class: "me-2"
}
const _hoisted_5 = { class: "me-2" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 1,
  class: "mt-2",
  style: {"color":"#666666"}
}

import { ref } from 'vue'
import UserQuestion from '../../../api/v2/models/user_question'
import User from '../../models/user'
import { checkMobile } from '../../utils/utils'
import Simplemde from '../atoms_molecules/Simplemde.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionList',
  props: {
    questions: {}
  },
  setup(__props: any) {

const props = __props

const isLoading = ref(true)

const relaticeObject = (userQuestion: UserQuestion) => {
  if (userQuestion.questionRelatives.length > 0) {
    return `${stringTruncate(userQuestion.relativeCourse, 10)} > ${stringTruncate(userQuestion.relativeLesson, 10)}`
  } else {
    return ""
  }
}

const stringTruncate = (str: string, length: number) => {
  if (checkMobile()){
    var dots = str.length > length ? '...' : '';
    return str.substring(0, length) + dots;
  } else {
    return str
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.questions.length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.questions, (question) => {
          return (_openBlock(), _createBlock(_component_v_list_item, {
            key: question.id,
            to: `/classroom/questions/${question.id}`,
            class: "ps-0 question-item"
          }, {
            prepend: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(question.answersCount), 1 /* TEXT */),
                _createElementVNode("div", {
                  class: _normalizeClass({ 'question-active': question.answersCount > 0, 'question-deactive': question.answersCount == 0 })
                }, " Ans ", 2 /* CLASS */)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_list_item_title, {
                  textContent: _toDisplayString(relaticeObject(question)),
                  class: "question-title-small"
                }, null, 8 /* PROPS */, ["textContent"]),
                _createVNode(_component_v_list_item_title, {
                  textContent: _toDisplayString(stringTruncate(question.title, 25)),
                  class: "question-title"
                }, null, 8 /* PROPS */, ["textContent"]),
                _createVNode(_component_v_list_item_subtitle, null, {
                  default: _withCtx(() => [
                    (question.createdAt)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(question.createdAt.substring(0, 10)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("span", _hoisted_5, [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createTextVNode("mdi-thumb-up", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }),
                      _createTextVNode(" " + _toDisplayString(question.voteValues), 1 /* TEXT */)
                    ]),
                    (question.user && question.user.image)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: question.user.image.url,
                          style: {"width":"15px"}
                        }, null, 8 /* PROPS */, _hoisted_6))
                      : _createCommentVNode("v-if", true),
                    (question.user && question.user.name)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(stringTruncate(question.user.name, 10)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */)
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (!isLoading.value && __props.questions.length == 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, "質問はまだありません。"))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})